export default {
    "profile": "Profil",
    "logout": "Çıkış Yap",
    "dashboard": "Gösterge Paneli",
    "password": "Şifre",
    "language": "Dil",
    "paymentbr": "Ödeme",
    "subscriptionPaymentMethod": "Abonelik ve Ödeme Yöntemi",
    "nothingchanged": "Hiçbirşey değişmedi",
    "somethingWentWrong": "Bir şeyler yanlış gitti ! Lütfen daha sonra tekrar deneyin",
    "pleaseTryAgainAfterSometime": "Lütfen bir süre sonra tekrar deneyin",
    "noChanges": "Değişmedi",
    "invalidEmailFormat": "E-posta biçimi geçersiz",
    "chooseYourPreferredLanguage": "Lütfen tercih ettiğiniz dili seçin.",
    "selectLanguage": "Dil Seçin",
    "update": "Güncelleme",
    "languagePreferences": "Dil Tercihleri",
    "packageOf": "Paket",
    "satelliteReport": "uydu raporları",
    "pastureReport": "mera raporları",
    "upTo": "Kadar",
    "animals": "hayvanlar",
    "back": "Geri",
    "perMonth": "Her ay",
    "perYear": "Yıl başına",
    "continue": "Devam etmek",
    "changePlan": "Plan değiştir",
    "addOn": "Ayriyeten",
    "totalPrice": "Toplam fiyat",
    "availableAddOns": "Mevcut Eklentiler",
    "next": "Sonraki",
    "congratulations": "Tebrikler",
    "done": "TAMAMLAMAK",
    "deforestationComplianceAssessment": "Ormansızlaşma Uygunluk Değerlendirmeleri",
    "warning": "Uyarı",
    "yourDataMightLost": "Verileriniz kaybolabilir.",
    "clickOnSaveBtnMsg": "Verilerinizi korumak için kaydet düğmesine tıklayın",
    "discardChanges": "Değişiklikleri gözardı et",
    "action": "Hareketler",
    "sendRequest": "İstek gönder",
    "success": "Başarı",
    "yourRequestSuccessfullySubmitted": "İsteğiniz başarıyla gönderildi.",
    "informShortly": "İsteğiniz başarıyla gönderildi. Analiz raporunuz kısa sürede tarafınıza gönderilecektir.",
    "search": "Aramak",
    "pending": "Askıda olması",
    "approved": "Onaylı",
    "rejected": "Reddedildi",
    "primaryGeofence": "Birincil Coğrafi Sınır",
    "Zero/Negligible Deforestation Probability": "Sıfır/Önemsiz Orman Kesme İhtimali",
    "Low Deforestation Probability": "Düşük Orman Kesme İhtimali",
    "High Deforestation Probability": "Yüksek Orman Kesme İhtimali",
    "login": {
        "welcome": "Hoş geldin! Giriş yapmak",
        "welInfo": "Kimlik bilgilerinizi girin.",
        "login": "Giriş yapmak",
        "emailMobile": "E-posta/Mobil",
        "forgotPassword": "Parolanızı mı unuttunuz",
        "register": "Kayıt olmak",
        "unableToLogin": "Giriş yapılamıyor",
        "emailMobileCannotEmpty": "E-posta/Mobil boş olamaz.",
        "invalidEmailMobileFormat": "Geçersiz e-posta/cep telefonu biçimi.",
        "passwordCannotEmpty": "Şifre boş olamaz.",
        "passwordLengthCanlessthan8": "Şifre uzunluğu 8 karakterden az olamaz.",
        "email": "E-posta",
        "phone": "Telefon",
        "or": "VEYA",
        "alreadyHaveAccount": "Zaten hesabınız var mı",
        "loginNow": "Şimdi giriş yap",
        "registerOption": "Kaydolmak için bir seçenek belirleyin",
        "signUpWith": "İle kayıt olun"
    },
    "user": {
        "profileUpdated": "Profil başarıyla güncellendi",
        "profileNotUpdated": "Profil güncellenmedi",
        "otpSentOnEmail": "OTP başarıyla gönderildi!",
        "otpSentSuccessFully": "OTP kodunuz gönderildi",
        "unableToVerifyEmail": "E-posta doğrulanamıyor",
        "emailCanNotBeEmpty": "E-posta alanları boş olamaz",
        "firstName": "İlk adı",
        "lastName": "Soy isim",
        "email": "E-posta",
        "mobile": "Mobil",
        "currentPassword": "Mevcut Şifre",
        "newPassword": "Yeni Şifre",
        "repeatNewPassword": "Yeni şifreyi tekrar girin",
        "firstNameRequired": "Ad gereklidir.",
        "lastNameRequired": "Soyadı gerekli",
        "emailRequired": "Email gereklidir",
        "onlyAlphabet": "Yalnızca alfabe içerebilir",
        "notMoreThan15Char": "15 karakterden fazla olamaz",
        "phoneCannotLessThan8Char": "Telefon 8 karakterden az olamaz",
        "countryCodeRequire": "Ülke kodu gerekli",
        "changePassword": "Şifre değiştir",
        "goodIdeaToUsePassword": "Başka bir yerde kullanmadığınız güçlü bir şifre kullanmak iyi bir fikirdir.",
        "enterCurrentPassword": "Güncel şifrenizi giriniz",
        "enterNewPassword": "Yeni Şifreyi Girin",
        "reEnterPassword": "Şifrenizi tekrar girin",
        "pleaseTypeOldPassword": "Lütfen eski şifrenizi yazın.",
        "pleaseTypeNewPassword": "Lütfen yeni şifreyi yazın.",
        "pleaseTypeConfirmPassword": "Lütfen şifreyi onaylayın.",
        "passwordChangedSuccesFully": "parola başarıyla değiştirildi",
        "passwordDoesNotMatch": "Parolalar eşleşmiyor.",
        "passwordRequired": "Şifre gereklidir",
        "emailOrPhoneIsRequired": "E-posta veya Telefon Numarası gerekli"
    },
    "subscription": {
        "subscription": "Abonelik",
        "membershipPlan": "Üyelik Planları",
        "currentMembershipPlan": "Mevcut üyelik planı",
        "validUpTo": "Geçerlilik Tarihi:",
        "viewAllAddOns": "TÜM EKLENTİLERİ GÖRÜNTÜLE",
        "renewValidity": "Geçerliliği Yenile",
        "buyNow": "Şimdi al",
        "upgradeMembershipPlan": "Üyelik planını yükseltin",
        "chooseYourMembershipPlan": "Seçtiğiniz Üyelik Planı",
        "chooseOptionalAddOns": "İsteğe bağlı Eklentileri seçebilirsiniz",
        "yourSelectedAddons": "Seçtiğiniz Eklentiler",
        "addAnotherAddOn": "Başka Bir Eklenti Ekle",
        "paymentMethod": "Ödeme yöntemi",
        "addingAPaymentMethod": "Ödeme Yöntemi Ekleme",
        "paymentSuccessful": "Ödemeniz Başarılı Oldu!",
        "weHaveEmailed": "Tarifenizin bir kopyasını example@email.com adresine e-postayla gönderdik.",
        "paymentAuthorizedSuccessfully": "Ödeme başarıyla onaylandı.",
        "paymentSuccessfulPrompt": "Ödeme başarılı. Plan yükseltildi.",
        "paymentCancelled": "Ödeme iptal edildi. Lütfen tekrar deneyin."
    },
    "registerFarm": "Çiftlik Kaydı",
    "requestDeforestationReport": "Ormansızlaşma Raporu İste",
    "paymentMenu": "Ödeme",
    "complianceCertificate": "Uygunluk belgesi",
    "helpDisk": "Yardım Diski",
    "faqs": "SSS'ler",
    "enquiries": "Araştırma",
    "contactUs": "Bize Ulaşın",
    "payment": {
        "basicPlan": "Temel Plan",
        "advancePlan": "Ön Plan",
        "usdPerMonthPlus": "Aylık USD artı",
        "perReport": "rapor başına",
        "deforestationAnalyticsCertificateDownload": "Ormansızlaşma analiz sertifikası indir"
    },
    "farm": {
        "farmOwnershipType": "Çiftlik Mülkiyet Türü",
        "licenceNum": "Lisans numarası",
        "viewFarm": "Çiftliği Görüntüle",
        "stateProvince": "İl/Eyalet",
        "postalNumberShouldSimilarToFarm": "Çiftliğin posta numarası Ev numarasına benzer.",
        "videoTutorial": "Video öğretici",
        "clickOnMapMSG": "Coğrafi sınırlamayı başlatmak için haritaya tıklayın",
        "prev": "Önceki",
        "next": "Sonraki",
        "dragVertexMsg": "Ayrıca köşeyi sürükleyebilir veya sağ taraftaki sil düğmesini kullanarak silebilirsiniz. Geofence, temizleme düğmesi kullanılarak da temizlenebilir",
        "farmAddedSuccessfully": "Çiftlik başarıyla eklendi",
        "perimeter": "Çevre",
        "area": "Alan",
        "clearGeofence": "Coğrafi Sınırı Temizle",
        "deleteSelectedVertex": "Seçilen Tepe Noktasını Sil",
        "pleaseStartDrawing": "Lütfen harita üzerinde coğrafi çit çizmeye başlayın.",
        "chooseTheDate": "Tarihi seçin",
        "updateGeofenceForThisFarm": "Bu çiftlik için GEOFENCE GÜNCELLEMESİ",
        "farmUpdateSuccessfully": "Çiftlik başarıyla güncellendi",
        "farmZone": "Çiftlik Bölgeleri",
        "addNewZones": "Yeni Bölgeler Ekle",
        "zoneName": "Bölge Adı",
        "addZoneToCreate": "Bu çiftliğe bir Bölge oluşturmak için lütfen Bölge Ekle'ye tıklayın.",
        "noZoneCreated": "Henüz hiçbir Bölge oluşturulmadı.",
        "searchAndAddPin": "Pin arayın ve ekleyin",
        "zoneNameWillBeHere": "Bölge Adı burada olacak",
        "editZone": "Bölgeyi Düzenle",
        "nameOfTheField": "Alanın Adı",
        "zoneDetails": "Bölge Detayları",
        "addZone": "Bölge Ekle",
        "nameOfTheZone": "Bölgenin Adı",
        "geofenceIsRequiredToAdd": "Bölge eklemek için coğrafi çit gereklidir. Çiftliğinize Geofence ayrıntılarını eklemek için \"Çiftliği Düzenle\"ye tıklayın.",
        "thisFieldApplyHelpText": "Bu alan yalnızca herhangi bir kooperatife üye olmanız durumunda sizin için geçerlidir ( Kooperatif, ortak ekonomik, sosyal ve kültürel ihtiyaç ve isteklerini ortaklaşa sahip olunan ve demokratik olarak kontrol edilen bir işletme aracılığıyla karşılamak için gönüllü olarak bir araya gelen kişilerin oluşturduğu özerk bir birliktir). Bir kooperatife aitseniz lütfen o kooperatifin benzersiz tanımlayıcısını belirtin; bu, bağlı olduğunuz kooperatifi benzersiz şekilde tanımlayan bir tescil veya lisans numarası olabilir.",
        "farmRegistrationID": "Çiftlik Kayıt Kimliği",
        "farmerName": "Çiftçi Adı",
        "farmerRegistrationID": "Çiftçi Kayıt Kimliği",
        "dateOfRequest": "Talep Tarihi",
        "status": "Durum",
        "address": "Adres",
        "save": "Kaydetmek",
        "farmAddress": "Çiftliğin Yeri Adres",
        "corporateName": "Şirket Adı",
        "corporateMailingAddress": "Kurumsal Posta Adresi",
        "farmID": "Çiftlik Kimliği",
        "onTheFarm": "Çiftlikte",
        "userRoles": "Kullanıcı rolleri",
        "adduser": "Kullanıcı Ekle",
        "addAuser": "Kullanıcı Ekle",
        "uploadUsers": "Kullanıcıları Yükle",
        "addNewUser": "Yeni Kullanıcı Ekle",
        "selectDept": "Departman Seçiniz",
        "selectRole": "Rol Seçin",
        "editUser": "kullanıcıyı düzenle",
        "totalFarms": "Toplam Çiftlik",
        "NoAnimalsRegisteredForthisFarm": "Bu Çiftlikte Kayıtlı Hayvan Yok",
        "farmsPerPage": "Sayfa başına çiftlikler",
        "regularFarms": "Düzenli Çiftlikler",
        "farmRegisteredProducts": "Çiftlik Kayıtlı Ürünler",
        "searchByFarmNameAndId": "Çiftlik Adına ve Kimliğine Göre Ara",
        "loadingProductsPleaseWait": "Ürünler Yükleniyor... Lütfen Bekleyin",
        "farmName": "Çiftlik Adı",
        "farmLocation": "Çiftliğin Konumu",
        "productName": "Ürün adı",
        "stockStatus": "Stok durumu",
        "inStock": "Stokta var",
        "searchByProductName": "Ürün Adına Göre Ara",
        "productCategory": "Ürün Kategorisi",
        "products": "Ürünler",
        "yourLocationIsDisabled": "Konumunuz devre dışı bırakıldı. Lütfen sol menülerden konumunuzu arayın.",
        "close": "Kapalı",
        "farms": "Çiftlikler",
        "zones": "Bölgeler",
        "registerAfarm": "Çiftliği Kaydet",
        "govtRegistry": "Hükümet Kayıt",
        "cooperativeID": "Kooperatif/Birlik Kimliği",
        "cooperativeName": "Kooperatif/Birlik Adı",
        "farmType": "Çiftlik Tipi",
        "contractMating": "Sözleşmeli Çiftleşme",
        "customization": "Özelleştirme",
        "recordsPerpage": "Sayfa başına kayıt",
        "restoreDefault": "Varsayılana döndür",
        "apply": "Uygula",
        "CommunityName": "Topluluk ismi",
        "searchState": "Çiftlik Kimliğine, Devlet Siciline, Kooperatif Kimliğine, Çiftlik Türüne, Sözleşmeli Çiftleştirmeye göre arama yapın",
        "farmOwner": "Çiftlik Sahibi",
        "govRegistrationNo": "Devlet Kayıt Numarası",
        "farmInformation": "Çiftlik Bilgileri",
        "ownershipType": "Mülkiyet Türü",
        "farmLicenseInformation": "Çiftlik Ruhsat Bilgileri",
        "licenseNumber": "Lisans numarası",
        "licenseExpiryDate": "Lisans Sona Erme Tarihi",
        "regulatorName": "Düzenleyici Adı",
        "regulatorRepresentativeName": "Düzenleyici Temsilcisi Adı",
        "farmLocationSize": "Çiftliğin Konumu ve Büyüklüğü",
        "productionSystem": "Tarım Sistemi",
        "country": "Ülke",
        "state": "Durum",
        "city": "Köy/Kasaba/Şehir",
        "farmNumber": "Çiftlik Numarası",
        "postal": "Posta/Posta Kodu",
        "houseNumber": "Ev numarası",
        "farmRegistration": "Çiftlik Kaydı",
        "cancel": "İptal etmek",
        "register": "Kayıt olmak",
        "ok": "Tamam",
        "totalFarmSize": "Toplam Çiftlik Büyüklüğü",
        "geographicLocation": "Coğrafi konum",
        "farmGeographicLocation": "Çiftliğin Coğrafi Konumu",
        "perimeterPointLongitude": "Çevre Noktası Boylamı",
        "perimeterPointLatitude": "Çevre Noktası Enlemi",
        "perimeterPointLabel": "Çevre Noktası Etiketi",
        "perimeterLength": "Çevre Uzunluğu",
        "farmLatitude": "Çiftlik Enlemi",
        "farmLongitude": "Çiftlik Boylamı",
        "latitude": "Enlem",
        "longitude": "Boylam",
        "areaUnit": "Alan Birimi",
        "walkAndMeasure": "YÜRÜYÜŞ VE ÖLÇÜM",
        "useGeofenceTool": "GEOFENCE ARACINI KULLANIN",
        "editFarm": "Çiftliği Düzenle",
        "update": "Güncelleme",
        "editAfarm": "Bir çiftliği düzenle",
        "nextFarm": "Sonraki Çiftlik",
        "nameoftheFarm": "Çiftliğin Adı",
        "registerAProduct": " Ürün Kaydet",
        "farmProducts": "Çiftlik Ürünleri",
        "calf": "Buzağı",
        "steer": "Yönlendir",
        "heifer": "Düve",
        "sire": "efendim",
        "dam": "Baraj",
        "registerAnAnimal": "Bir Hayvanı Kaydettirin",
        "farmAnimals": "Çiftlik hayvanları",
        "farm_type": "Çiftlik tipi",
        "farm_Owner": "Çiftlik Sahibi",
        "dateOfRegistration": "Kayıt Tarihi",
        "dataIsNotAvailableForThisFarm": "Bu Çiftlik için Veri Mevcut Değil",
        "registerNewProduct": "Yeni Bir Ürün Kaydedin",
        "information": "Bilgi",
        "licenseInfo": "Lisans Bilgileri",
        "locationInfo": "Konum Bilgisi",
        "geoLocation": "Coğrafi Konum",
        "perimeterLengthState": "Çiftlik Çevresinin Uzunluğu (çit uzunluğu)",
        "totalFarmSizeState": "Çiftliğin Büyüklüğü",
        "productionSystemState": "Çiftlikte Kullanılan Üretim Sistemi",
        "contractMatingState": "Çiftliğin Katıldığı Sözleşmeli Çiftleştirme Programının Kuralları.",
        "ownershipTypeState": "Sahiplik türü",
        "regulatorRepresentativeNameState": "Lisansı veren düzenleyiciyi temsil eden kişinin adı",
        "regulatorNameState": "Lisansı veren düzenleyicinin adı",
        "licenseExpiryDateState": "Mevcut Lisansın Sona Erdiği Tarih",
        "licenseNumberState": "Düzenleyici Tarafından Yayınlanan Lisans Numarası",
        "plotNumberState": "Çiftliğin ev numarası.",
        "plotNumber": "Çiftlik Numarası",
        "streetStatement": "Çiftliğin sokak adı.",
        "cityStatement": "Çiftliğin bulunduğu şehir.",
        "stateStatement": "Çiftliğin bulunduğu ülkenin bölgesi.",
        "countryState": "Çiftliğin bulunduğu ülke.",
        "farmStateInfo": "Çiftliğin bulunduğu yerin adresi",
        "perimeterPointLongitudeState": "Çiftlikte bir noktanın boylamı.",
        "perimeterPointLatitudeState": "Çiftlikte bir noktanın enlemi.",
        "perimeterPointLabelState": "Noktanın Etiketi.",
        "farmLongitudeState": "Çiftliğin boylamı.",
        "farmLatitudeState": "Çiftliğin enlemi.",
        "deleteFarm": "Çiftliği Sil",
        "corporateRegistrationNum": "Kurumsal Sicil Numarası",
        "farmLocationIsRequired": "Çiftlik Konumu gerekli."
    },
    "deforestation": {
        "addZoneToThisFarm": "Bu çiftliğe Bölgeler ekleyin",
        "eudrForestAssessment": "EUDR Orman Değerlendirmeleri",
        "requestEudrForestAssessment": "EUDR ORMAN DEĞERLENDİRMESİ TALEP EDİN",
        "pleaseChooseOption": "Lütfen Seçeneği Seçiniz",
        "requestForestReport": "Orman Raporu İste",
        "noDeforestationReportMsg": "Hiçbir ormansızlaşma raporu talep edilmedi. Lütfen burada listelenmesi için bazı ormansızlaşma raporları isteyin.",
        "allCountries": "Tüm ülkeler",
        "allRegions": "Tüm bölgeler",
        "allFarms": "Tüm Çiftlikler",
        "allStatus": "Tüm Durumlar",
        "viewCertificate": "Sertifikayı Görüntüle",
        "requestComplianceCertificate": "UYGUNLUK BELGESİ TALEP EDİN",
        "assessmentNo": "Değerlendirme Hayır",
        "blockchainCertificationInfo": "Blockchain Sertifika Doğrulama Karması, Sertifikanın Kabul Edilmesiyle Mevcut Olacaktır",
        "blockchainCertificationValidation": "Blockchain Sertifika Doğrulaması",
        "openBlockchainPage": "Blockchain Sayfasını Aç",
        "clickOnAboveLink": "Blockchain'deki sertifikayı doğrulamak için yukarıdaki bağlantıya tıklayın",
        "shareCertificate": "Hisse senedi",
        "high": "Yüksek",
        "low": "Düşük",
        "zeroOrNegigible": "Sıfır veya İhmal Edilebilir",
        "deforestationProbability": "Ormansızlaşma Olasılığı",
        "colorCode": "Renk kodu",
        "geofenceAarea": "Geofence Alanı",
        "percentageOfGeofenceArea": "Geofence Alanı Yüzdesi",
        "overallDeforestationProbability": "Genel Ormansızlaşma Olasılığı",
        "deforestationComplianceReport": "Ormansızlaşma Uygunluk Raporları",
        "noDeforestationComplianceReport": "Ormansızlaşma Uyumluluğuna İlişkin eRapor Bulunamadı",
        "loadingDeforestationComplianceReport": "Ormansızlaşma Uyumluluğu eRaporu Yükleniyor",
        "farmRegistrationId": "Çiftlik Kayıt Kimliği",
        "farmerName": "Çiftçi Adı",
        "farmerRegistrationId": "Çiftçi Kayıt Kimliği",
        "uniqueFarmerId": "Benzersiz Çiftçi Kimliği",
        "uniqueFarmId": "Benzersiz Çiftlik Kimliği",
        "farmLocation": "Çiftliğin Konumu",
        "area": "Alan",
        "farmAddress": "Çiftlik Adresi",
        "dateOfRequest": "Talep Tarihi",
        "status": "Durum",
        "settings": "Ayarlar",
        "assignmentIssued": "Ödev Verildi",
        "certificateIssued": "Sertifika Verildi",
        "complianceCertification": "Uyumluluk Sertifikası",
        "noComplianceCertification": "Uygunluk Sertifikası Bulunamadı",
        "loadingComplianceCertification": "Uyumluluk Sertifikası Yükleniyor",
        "assessmentReport": "Değerlendirme raporu",
        "downloadPDF": "PDF İndir",
        "print": "Yazdır",
        "back": "Geri",
        "farmDetails": "Çiftlik Detayları",
        "dimitraFarmId": "Dimitra Çiftliği Kimliği",
        "dimitraFermerId": "Dimitra Çiftçi Kimliği",
        "totalGeofenceAreaHA": "Toplam Geofence Alanı (HA)",
        "forestLossHA": "Orman Kaybı (HA)",
        "forestGainHA": "Orman Kazanımı (HA)",
        "forestUnchangedHA": "Orman Değişmedi (HA)",
        "forestUnchanged": "Orman Değişmedi",
        "forestLoss": "Orman Kaybı",
        "forestGain": "Orman Kazanımı",
        "totalGeofenceArea": "Toplam Geofence Alanı",
        "forestAssessmentHelp": "Bu raporla ilgili sorularınız varsa veya raporu anlama konusunda yardıma ihtiyacınız varsa Yardım Masası aracılığıyla bizimle iletişime geçin.",
        "allReport": "Tüm Raporlar",
        "deforestationRepot": "Ormansızlaşma Raporları",
        "requestDeforestationReportNow": "ORMAN KESİLME RAPORUNU ŞİMDİ İSTEYİN",
        "noRecordFound": "Kayıt Bulunamadı",
        "noDeforestationReportRequested": "Hiçbir ormansızlaşma raporu talep edilmedi. Lütfen burada listelenmesi için bazı ormansızlaşma raporları isteyin.",
        "deforestationImage": "Ormansızlaşma Resmi",
        "reqDeforestationReport": "Ormansızlaşma Raporu İste",
        "confirm": "Onaylamak",
        "newForestArea": "Yeni Orman Alanı",
        "deforestedArea": "Ormansız Alan",
        "existingForestArea": "Mevcut Orman Alanı",
        "deforestation": "Ormansızlaşma",
        "farmName": "Çiftlik Adı",
        "location": "Konum",
        "dateOfInterest": "İlgi Tarihi",
        "geofenceArea": "GeofenceArea (HA)",
        "deforestationArea": "Ormansızlaşma Alanı (HA)",
        "treeGainArea": "Ağaç Kazanım Alanı (HA)",
        "currentForestArea": "Mevcut Orman Alanı (HA)",
        "view": "Görüş",
        "locationInfoRequired": "Konum Bilgisi Gereklidir",
        "geofenceNameRequired": "Coğrafi sınır adı Gerekli",
        "futureDateSelected": "Gelecek tarih seçildi",
        "reportGeneratedSuccessfully": "Rapor başarıyla oluşturuldu",
        "reportCannotAdded": "Rapor eklenemiyor.",
        "primaryFarmNotFound": "Birincil çiftlik bulunamadı.",
        "pleaseRegisterFarmFirst": "Lütfen önce çiftliği kaydedin"
    },
    "certificate": {
        "allCertificate": "Tüm Sertifikalar",
        "certificate": "Sertifika"
    }
}